(function () {
  function splitHeadingAndBody(block) {
    const content = block.querySelector(".rhh-collection-description__content");
    if (!content || content.dataset.rhhSplit === "true") return;

    const source = content.querySelector(".rhh-collection-description__text");
    if (!source) return;

    const headingWrap = document.createElement("div");
    headingWrap.className = "rhh-collection-description__heading";

    const bodyWrap = document.createElement("div");
    bodyWrap.className = "rhh-collection-description__body";

    const bodyText = document.createElement("div");
    bodyText.className = "rhh-collection-description__text rte";

    const firstHeading = source.querySelector("h1, h2, h3");
    if (firstHeading) {
      const heading = firstHeading.cloneNode(true);
      heading.classList.add("m-collection-page-header__title");
      headingWrap.appendChild(heading);
      firstHeading.remove();
    }

    while (source.firstChild) {
      bodyText.appendChild(source.firstChild);
    }

    source.remove();

    if (headingWrap.childElementCount) {
      content.insertBefore(headingWrap, content.firstChild);
    }

    if (bodyText.childNodes.length) {
      bodyWrap.appendChild(bodyText);
      content.appendChild(bodyWrap);
    }

    content.dataset.rhhSplit = "true";
  }

  function setCollapsedMaxHeight(block, textEl) {
    const style = window.getComputedStyle(textEl);
    const fontSize = parseFloat(style.fontSize) || 15;
    const lineHeight = style.lineHeight === "normal" ? fontSize * 1.45 : parseFloat(style.lineHeight);
    const collapsedHeight = lineHeight * 2;
    textEl.style.setProperty("--rhh-collapsed-max", collapsedHeight + "px");
  }

  function textOverflows(textEl) {
    return textEl.scrollHeight > textEl.clientHeight + 1;
  }

  function refreshCollectionDescription(block) {
    const textEl = block.querySelector(".rhh-collection-description__body .rhh-collection-description__text");
    const toggle = block.querySelector(".rhh-collection-description__toggle");
    if (!toggle) return;

    const readMore = toggle.dataset.readMore || "... read more";
    const readLess = toggle.dataset.readLess || "read less";

    if (!textEl) {
      toggle.hidden = true;
      block.classList.remove("rhh-collection-description--clampable", "rhh-collection-description--expanded");
      return;
    }

    const isExpanded = block.classList.contains("rhh-collection-description--expanded");

    if (isExpanded) {
      textEl.style.removeProperty("--rhh-collapsed-max");
      block.classList.add("rhh-collection-description--clampable");
      toggle.hidden = false;
      toggle.textContent = readLess;
      toggle.setAttribute("aria-expanded", "true");
      return;
    }

    setCollapsedMaxHeight(block, textEl);

    const overflows = textOverflows(textEl);

    if (overflows) {
      block.classList.add("rhh-collection-description--clampable");
      toggle.hidden = false;
      toggle.textContent = readMore;
      toggle.setAttribute("aria-expanded", "false");
    } else {
      block.classList.remove("rhh-collection-description--clampable");
      toggle.hidden = true;
      textEl.style.removeProperty("--rhh-collapsed-max");
    }
  }

  function scheduleRefresh(block) {
    refreshCollectionDescription(block);
    window.requestAnimationFrame(() => refreshCollectionDescription(block));
  }

  function initCollectionDescription(root) {
    root.querySelectorAll(".rhh-collection-description--expandable").forEach((block) => {
      splitHeadingAndBody(block);

      const bodyWrap = block.querySelector(".rhh-collection-description__body");
      const toggle = block.querySelector(".rhh-collection-description__toggle");
      if (!toggle) return;

      if (bodyWrap && !bodyWrap.contains(toggle)) {
        bodyWrap.appendChild(toggle);
      }

      if (block.dataset.rhhCollectionDescInit !== "true") {
        block.dataset.rhhCollectionDescInit = "true";

        toggle.addEventListener("click", () => {
          const expanded = block.classList.toggle("rhh-collection-description--expanded");
          toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
          refreshCollectionDescription(block);
        });

        const textEl = block.querySelector(".rhh-collection-description__body .rhh-collection-description__text");
        if (textEl && typeof ResizeObserver !== "undefined") {
          const observer = new ResizeObserver(() => refreshCollectionDescription(block));
          observer.observe(textEl);
        }
      }

      scheduleRefresh(block);
    });
  }

  function boot() {
    initCollectionDescription(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("load", boot);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(boot);
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target) initCollectionDescription(event.target);
    });
  }
})();
